import type { PrismTheme } from 'prism-react-renderer';
import type { ExtendedTheme } from '@theme/theme';

export const codeSnippetLightTheme = (theme: ExtendedTheme): PrismTheme => ({
  plain: {
    color: '#000',
    backgroundColor: theme.palette.components.codeBgLight,
  },
  styles: [
    {
      types: ['prolog', 'doctype', 'cdata'],
      style: {
        color: '#999988',
        fontStyle: 'italic',
      },
    },
    {
      types: ['namespace'],
      style: {
        opacity: 0.7,
      },
    },
    {
      types: ['attr-value', 'string'],
      style: {
        color: '#007600',
      },
    },
    {
      types: ['punctuation', 'operator'],
      style: {
        color: '#660',
      },
    },
    {
      types: ['variable'],
      style: {
        color: '#606',
      },
    },
    {
      types: ['entity', 'url', 'symbol', 'number', 'constant', 'regex', 'inserted', 'boolean'],
      style: {
        color: '#066',
      },
    },
    {
      types: ['url', 'property', 'comment'],
      style: {
        color: '#800',
      },
    },
    {
      types: ['atrule', 'selector'],
      style: {
        color: '#00a4db',
      },
    },
    {
      types: ['tag', 'keyword'],
      style: {
        color: '#008',
      },
    },
    {
      types: ['deleted', 'attr-name'],
      style: {
        color: '#000',
      },
    },
    {
      types: ['function'],
      style: {
        color: '#606',
      },
    },
    {
      types: ['function-variable'],
      style: {
        color: '#6f42c1',
      },
    },
    {
      types: ['selector'],
      style: {
        color: '#7928a1',
      },
    },
  ],
});

export const codeSnippetDarkTheme = (theme: ExtendedTheme): PrismTheme => ({
  plain: {
    color: '#fff',
    backgroundColor: theme.palette.components.codeBgDark,
  },
  styles: [
    {
      types: ['prolog', 'doctype', 'cdata'],
      style: {
        color: '#999988',
        fontStyle: 'italic',
      },
    },
    {
      types: ['namespace'],
      style: {
        opacity: 0.7,
      },
    },
    {
      types: ['attr-value', 'string'],
      style: {
        color: '#00bda0',
      },
    },
    {
      types: ['punctuation', 'operator'],
      style: {
        color: '#fff',
      },
    },
    {
      types: ['variable'],
      style: {
        color: '#89bdff',
      },
    },
    {
      types: ['entity', 'url', 'symbol', 'number', 'constant', 'regex', 'inserted', 'boolean'],
      style: {
        color: '#ffcb8f',
      },
    },
    {
      types: ['url', 'property', 'comment'],
      style: {
        color: '#aeaeae',
      },
    },
    {
      types: ['atrule', 'selector'],
      style: {
        color: '#89bdff',
      },
    },
    {
      types: ['tag', 'keyword'],
      style: {
        color: '#f08a92',
      },
    },
    {
      types: ['deleted', 'attr-name'],
      style: {
        color: '#fff',
      },
    },
    {
      types: ['function'],
      style: {
        color: '#89bdff',
      },
    },
    {
      types: ['function-variable'],
      style: {
        color: '#6f42c1',
      },
    },
    {
      types: ['selector'],
      style: {
        color: '#89bdff',
        fontWeight: 'bold',
      },
    },
  ],
});
